import { postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const postReferAFriend = (data) =>
  postRequest(
    replaceInUrl(apiEndpoints.referralCode.referAFriend, {
      accountUid: data.accountUid,
    }),
    data.referees,
  );
